export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <rect stroke="#979797" strokeWidth="2" x="19" y="15" width="36.4" height="46" rx="3" />
                <path
                    d="M63.762 18.115a2.99 2.99 0 0 1 2.121.879 2.99 2.99 0 0 1 .879 2.121h0v16.857c0 .75-.304 1.428-.795 1.92a2.706 2.706 0 0 1-1.92.795c-.749 0-1.427-.304-1.919-.795a2.706 2.706 0 0 1-.795-1.92h0V26.205h-6.171v-8.09z"
                    stroke="#979797"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path stroke="#979797" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" d="M18.229 21.026H10l8.229 21.943" />
                <path stroke="#979797" strokeWidth="2" strokeLinecap="round" d="M19.133 49.4h35.658" />
            </g>
        </svg>
    );
}
